import { getParent } from './getParent';
/**
 * Finds the first parent element where the matchFunction returns true
 * @param element - element to start searching at
 * @param matchFunction - the function that determines if the element is a match
 * @returns the matched element or null no match was found
 */
export function findElementRecursive(element, matchFunction) {
    if (!element || element === document.body) {
        return null;
    }
    return matchFunction(element) ? element : findElementRecursive(getParent(element), matchFunction);
}
//# sourceMappingURL=findElementRecursive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/node_modules/@uifabric/styling/node_modules/@uifabric/utilities/lib/dom/findElementRecursive.js
// module id = 127
// module chunks = 0